export const OT_USER_LOCALSTORAGE_KEY = 'is_ot_user';
export const OT_USER_LOCALSTORAGE_VALUE = 'true';
export const OT_CALLBACK_QUERY_KEY = 'integration';
export const OT_CALLBACK_QUERY_VALUE = 'opentable';
export const OT_AUTH_PARAMS = {
  scope: 'openid profile email offline_access',
  response_type: 'code',
  screen_hint: 'login-only',
  connection: 'Self-Serve-Signup',
  prompt: 'login',
  'ext-brand': 'opentable',
  response_mode: 'query',
};
